import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.00015 0.585938L5.41436 3.00015L4.00015 4.41436L1.58594 2.00015L3.00015 0.585938ZM22.4144 2.00015L20.0002 4.41436L18.5859 3.00015L21.0002 0.585938L22.4144 2.00015ZM10.3566 3.30271C10.0441 3.2966 9.77107 3.51304 9.70576 3.81877L7.42519 14.4933L6.20845 15.71L8.90974 18.4113L10.4369 16.8841C10.7951 16.5259 10.9964 16.0401 10.9964 15.5335L10.9964 3.9551C10.9964 3.5997 10.712 3.30966 10.3566 3.30271ZM7.74989 3.4009C8.01542 2.15809 9.12513 1.27824 10.3957 1.30309C11.0026 1.31497 11.5585 1.52992 11.9992 1.88235C12.4399 1.52992 12.9958 1.31497 13.6026 1.30309C14.8733 1.27824 15.983 2.15809 16.2485 3.4009L18.4055 13.4972L22.6761 17.7678L17.1464 23.2975L12.1473 18.2983C12.0963 18.2474 12.047 18.1952 11.9992 18.1419C11.9514 18.1952 11.902 18.2474 11.8511 18.2983L6.85199 23.2975L1.32227 17.7678L5.59287 13.4972L7.74989 3.4009ZM14.2926 3.81877C14.2273 3.51304 13.9543 3.2966 13.6418 3.30271C13.2864 3.30966 13.002 3.5997 13.002 3.9551L13.002 15.5335C13.002 16.0401 13.2033 16.5259 13.5615 16.8841L15.0886 18.4113L17.7899 15.71L16.5732 14.4933L14.2926 3.81877ZM5.41436 7.00015L3.00015 9.41436L1.58594 8.00015L4.00015 5.58594L5.41436 7.00015ZM20.0002 5.58594L22.4144 8.00015L21.0002 9.41436L18.5859 7.00015L20.0002 5.58594Z"}}]};

const GestureApplauseFilled = Vue.extend<IconProps>({
  name: 'GestureApplauseFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-applause-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureApplauseFilled;
